export default __webpack_public_path__ + "static/media/inventory.3cf707fe.png";